import {
    GETGATEWAYACCOUNT_SUCCESS,
    GETGATEWAYACCOUNT_FAILED,
    RESET_GETGATEWAYACCOUNT,
    LOADING_GETGATEWAYACCOUNT,
    NETWORK_ERROR_GETGATEWAYACCOUNT
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetGatewayAccount = () => {
    return { type: RESET_GETGATEWAYACCOUNT };
};

const getGatewayAccount = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETGATEWAYACCOUNT });
    await partnerServices
        .post("getGatewayAccountList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getGatewayAccountsuccess(res.data));
                    break;
                default:
                    dispatch(getGatewayAccountFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETGATEWAYACCOUNT,
                payload: err
            });
        });
};
function getGatewayAccountsuccess(data) {
    return {
        type: GETGATEWAYACCOUNT_SUCCESS,
        payload: data
    };
}
function getGatewayAccountFailed(data) {
    return {
        type: GETGATEWAYACCOUNT_FAILED,
        payload: data
    };
}

export { resetGetGatewayAccount, getGatewayAccount };
